import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { TutorialVideoService } from 'brain-data/service/tutorial-video/tutorial-video.service';
import {
  deleteTutorialVideo,
  deleteTutorialVideoError,
  deleteTutorialVideoSuccess,
  loadTutorialVideos,
  loadTutorialVideosError,
  loadTutorialVideosSuccess,
  updateTutorialVideo,
  updateTutorialVideoError,
  updateTutorialVideoSuccess,
  uploadTutorialVideo,
  uploadTutorialVideoError,
  uploadTutorialVideoSuccess,
} from '../actions/tutorial-video.action';

@Injectable()
export class TutorialVideoEffects {
  loadTutorialVideos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTutorialVideos),
      switchMap(() =>
        this.service.getAll().pipe(
          map(videos => loadTutorialVideosSuccess({ videos })),
          catchError((error: HttpErrorResponse) => of(loadTutorialVideosError({ error }))),
        ),
      ),
    ),
  );

  uploadTutorialVideo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uploadTutorialVideo),
      switchMap(({ payload }) =>
        this.service.upload(payload).pipe(
          map(video => uploadTutorialVideoSuccess({ video })),
          catchError((error: HttpErrorResponse) => of(uploadTutorialVideoError({ error }))),
        ),
      ),
    ),
  );

  updateTutorialVideo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateTutorialVideo),
      switchMap(({ payload }) =>
        this.service.update(payload).pipe(
          map(video => updateTutorialVideoSuccess({ previousId: payload.tutorialId, video })),
          catchError((error: HttpErrorResponse) => of(updateTutorialVideoError({ error }))),
        ),
      ),
    ),
  );

  deleteTutorialVideo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteTutorialVideo),
      switchMap(({ tutorialId }) =>
        this.service.delete(tutorialId).pipe(
          map(() => deleteTutorialVideoSuccess({ tutorialId })),
          catchError((error: HttpErrorResponse) => of(deleteTutorialVideoError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: TutorialVideoService,
  ) {}
}
